const recordImages = [
    'https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ29hZnh1ZzY1ejJyZnYwMWdmc3h1MmdnOXgxejh2eXlxNGMyNG9iZCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/PKJgLDtBDRraQzYkaM/giphy.gif',
    'https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExOXNnOW8wZXFxOTUxMzk1aHhlbWZoMHF0OXJrZW91dXViN3RzNnd6MyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Woaf96D8NFRrq/giphy.gif',
    'https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExbnZrdW5qdmpodTk2eHoyd3ZuNGZlaGRtbXZpb3R1Y29tYTh4a2xyZSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l0MYGeMQjSqhQ3UaI/giphy.gif'
  ];
  
  export default recordImages;
  